<template>
    <div class="message" v-if="payload.message != undefined">{{ payload.message }}</div>
    <v-text-field clearable :label="payload.placeholder" v-model="model.value" autofocus :rules="rules"></v-text-field>
</template>

<script>
export default {
    name: 'DialogInput',
    props: {
        payload: Object,
    },
    data() {
        return {
            model: this.payload,
        };
    },
    computed: {
        rules() {
            return [
                (value) => {
                    const error = this.rule(value);
                    if (error === false) {
                        return '';
                    } if (error === true) {
                        return true;
                    }
                    return error;
                },
            ];
        },
    },
    methods: {
        rule(value) {
            const validate = this.payload.validate;
            if (validate != null) {
                return validate(value);
            }
            return true;
        },
        finallize() {
            return this.rule(this.payload.value) === true;
        },
    },
};
</script>

<style scoped>
.message {
    padding-bottom: 16px;
    max-width: 400px;
}
</style>
